import {http} from "..";

export const requestRentPassport = async values =>
  http.post(`/agent/branch-connections/send-agent-invite`, values);

export const requestRPGuarantor = async values =>
  http.post(`/agent/branch-connections/guarantor/send-agent-invite`, values);

// TODO: Remove with old rp page
export const requestFullScreening = async values => http.post(`/full-reference-request`, values);

export const requestFullScreeningBranchConnection = async branchConnectionId =>
  http.post(`/full-reference-request/branch-connection/${branchConnectionId}`);

// TODO: Remove this when old screening is disabled
export const requestFullScreeningFromGuarantorNoConnection = async ({
  branchId,
  guarantorId,
  renterId,
}) =>
  http.post(`/agent/guarantor-request/request-full-referencing`, {branchId, guarantorId, renterId});

export const changeBranchConnectionsTenancyStatusRequest = async values =>
  http.post(`/agent/branch-connections/tenancy-status`, values);
